import { getLast7DaysDateRange } from "../pages/Rajasthan/Utility/const";
import {
  DEFAULT_DATES,
  generatePairedDateRanges,
} from "../pages/Rajasthan/Demand/Data";
import { DEFAULT_DATES as DEFAULT_DATES_HPPC } from "../pages/Hppc/Demand/Data";
import { DEFAULT_DATES as DEFAULT_DATES_GENRATION_TREND } from "../pages/Rajasthan/Generation/Data";
import { generateMonthRanges } from "../components/Search";
import {
  generateDateRangesForYearRange,
  generateMonthsFrom2021ToLatest,
} from "../pages/Gridco/Demand/Data";
// Helper function to get current date + 6 months
function getCurrentMonthLabel() {
  const now = new Date();

  return (
    now
      .toLocaleString("en-US", {
        month: "short",
      })
      .toUpperCase() +
    "-" +
    String(now.getFullYear()).slice(2)
  );
}

function getCurrentMonthRange() {
  const now = new Date();

  const start = new Date(now.getFullYear(), now.getMonth(), 1);
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);

  const format = (d) => {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  return `${format(start)},${format(end)}`;
}
const getCurrentDatePlus6Months = () => {
  const now = new Date();
  const futureDate = new Date(
    now.getFullYear(),
    now.getMonth() + 5,
    now.getDate(),
  );
  return {
    month: futureDate.getMonth(),
    year: futureDate.getFullYear(),
  };
};

const currentLabel = getCurrentMonthLabel();
const currentRange = getCurrentMonthRange();

export const RuvitalDemand = {
  "Discom Load ": {
    type: "range",
    // defaultRangeDate: getLast7DaysDateRange(),
    defaultRangeDate: {
      startDate: new Date("2026-01-05"),
      endDate: new Date("2026-01-11"),
      key: "selection",
    },
  },
  // "Trend Analysis": {
  //   type: "trend",
  //   trendDateOptions: generatePairedDateRanges(
  //     { month: 0, year: 2021 }, // Actual start: Jan 2021
  //     { month: new Date().getMonth(), year: new Date().getFullYear() }, // Actual end: current month/year
  //     { month: 8, year: 2025 }, // Forecast start: Jan 2025
  //     getCurrentDatePlus6Months(), // Forecast end: current date + 6 months
  //     "Model 1"
  //   ),
  //   defaultTrendDates: [
  //     { value: "2025-09-01,2025-09-30", label: "SEP-25" },
  //     {
  //       value: "2025-09-01,2025-09-30,Model 1",
  //       label: "SEP-25 (Forecast)",
  //       forecast: true,
  //       model: "Model 1",
  //     },
  //   ],
  // },
  "Trend Analysis": {
    type: "trend",

    trendDateOptions: generatePairedDateRanges(
      { month: 0, year: 2021 },
      { month: new Date().getMonth(), year: new Date().getFullYear() },
      { month: 8, year: 2025 },
      getCurrentDatePlus6Months(),
      "Model 1",
    ),

    defaultTrendDates: [
      {
        value: currentRange,
        label: currentLabel,
      },
      {
        value: `${currentRange},Model 1`,
        label: `${currentLabel} (Forecast)`,
        forecast: true,
        model: "Model 1",
      },
    ],
  },
  "Restricted Demand": {
    type: "range",
    // defaultRangeDate: getLast7DaysDateRange(),
    defaultRangeDate: {
      startDate: new Date("2026-01-05"),
      endDate: new Date("2026-01-11"),
      key: "selection",
    },
  },
  "Restricted Demand Trend Analysis": {
    type: "trend",
    trendDateOptions: generatePairedDateRanges(
      { month: 0, year: 2021 }, // Actual start: Jan 2021
      { month: new Date().getMonth(), year: new Date().getFullYear() }, // Actual end: current month/year
      undefined, // Forecast start: undefined
      undefined, // Forecast end: undefined
      "Model 1",
    ),
    defaultTrendDates: [
      // { value: "2025-11-01,2025-11-30,Model 1", label: "NOV-25 Forecast" },
      // { value: "2025-09-01,2025-09-30", label: "SEP-25" },
      { value: `${currentRange}`, label: `${currentLabel}` },
    ],
  },
  "Forecast Discom Load": {
    type: "range",
    defaultRangeDate: getLast7DaysDateRange(),
  },
};

export const RuvitalOverview = {
  "By Summary": {
    type: "range",
    // defaultRangeDate: getLast7DaysDateRange(),
    defaultRangeDate: {
      startDate: new Date("2026-01-05"),
      endDate: new Date("2026-01-11"),
      key: "selection",
    },
  },

  "By Product": {
    type: "range",
    // defaultRangeDate: getLast7DaysDateRange(),
    defaultRangeDate: {
      startDate: new Date("2026-01-05"),
      endDate: new Date("2026-01-11"),
      key: "selection",
    },
  },
};

export const RuvitalPowerProcurement = {
  Overview: {
    type: "range",
    defaultRangeDate: {
      startDate: new Date("2026-01-05"),
      endDate: new Date("2026-01-11"),
      key: "selection",
    },
    // defaultRangeDate: getLast7DaysDateRange(),
  },
  Collective: {
    type: "range",
    defaultRangeDate: {
      startDate: new Date("2026-01-05"),
      endDate: new Date("2026-01-11"),
      key: "selection",
    },
    // defaultRangeDate: getLast7DaysDateRange(),
  },
  "GNA/TGNA": {
    type: "range",
    defaultRangeDate: {
      startDate: new Date("2026-01-05"),
      endDate: new Date("2026-01-11"),
      key: "selection",
    },
    // defaultRangeDate: getLast7DaysDateRange(),
  },
  "Trend Analysis": {
    type: "range",
    // trendDateOptions: DEFAULT_DATES_GENRATION_TREND,
    trendDateOptions: generatePairedDateRanges(
      { month: 0, year: 2023 },
      { month: new Date().getMonth(), year: new Date().getFullYear() },
    ),
    defaultTrendDates: [
      // { value: "2024-12-01,2024-12-31", label: "DEC-24" }
      {
        value: currentRange,
        label: currentLabel,
      },
    ],
  },
};

export const RuvitalGenration = {
  Overview: {
    type: "range",
    // defaultRangeDate: getLast7DaysDateRange(),
    defaultRangeDate: {
      startDate: new Date("2026-01-05"),
      endDate: new Date("2026-01-11"),
      key: "selection",
    },
  },
  "Trend Analysis": {
    type: "trend",
    trendDateOptions: generatePairedDateRanges(
      { month: 0, year: 2023 },
      { month: new Date().getMonth(), year: new Date().getFullYear() },
    ),
    defaultTrendDates: [
      {
        value: currentRange,
        label: currentLabel,
      },
    ],
    // trendDateOptions: DEFAULT_DATES_GENRATION_TREND,
    // defaultTrendDates: [{ value: "2025-01-01,2025-01-31", label: "JAN-25" }],
  },
  "By Source": {
    type: "range",
    defaultRangeDate: {
      startDate: new Date("2026-01-05"),
      endDate: new Date("2026-01-11"),
      key: "selection",
    },
    // defaultRangeDate: getLast7DaysDateRange(),
  },
  "By Power Station": {
    type: "range",
    defaultRangeDate: {
      startDate: new Date("2026-01-05"),
      endDate: new Date("2026-01-11"),
      key: "selection",
    },
    // defaultRangeDate: getLast7DaysDateRange(),
    dateRangeDateOptions: [],
    showDateRange: false,
  },
  "Operating Parameters": {
    type: "range",
    defaultRangeDate: getLast7DaysDateRange(),
  },
  Outage: {
    type: "range",
    defaultRangeDate: getLast7DaysDateRange(),
  },
};

export const GridcoPowerProcurementDefaultDates = {
  Collective: {
    type: "range",
    defaultRangeDate: {
      startDate: new Date("2024-01-01"),
      endDate: new Date("2024-01-10"),
      key: "selection",
    },
  },
};

export const GridcoPowerGenrationDefaultDates = {
  Overview: {
    type: "range",
    defaultRangeDate: {
      startDate: new Date("2024-01-01"),
      endDate: new Date("2024-01-10"),
      key: "selection",
    },
  },
  "Trend Analysis": {
    type: "trend",
    trendDateOptions: generateDateRangesForYearRange(2022, 2025),
    defaultTrendDates: [{ value: "2024-01-01,2024-01-31", label: "JAN-24" }],
  },
  ISGS: {
    type: "range",
    defaultRangeDate: {
      startDate: new Date("2024-01-01"),
      endDate: new Date("2024-01-10"),
      key: "selection",
    },
  },
  Intrastate: {
    type: "range",
    defaultRangeDate: {
      startDate: new Date("2024-01-01"),
      endDate: new Date("2024-01-10"),
      key: "selection",
    },
  },
};

export const GridcoPowerDemandDefaultDates = {
  "Discom Load": {
    type: "range",
    defaultRangeDate: {
      startDate: new Date("2025-01-01"),
      endDate: new Date("2025-01-10"),
      key: "selection",
    },
  },
  "Trend Analysis": {
    type: "trend",
    trendDateOptions: generateDateRangesForYearRange(2022, 2025),
    defaultTrendDates: [{ value: "2024-01-01,2024-01-31", label: "JAN-24" }],
  },
  "Sub Station with OA": {
    type: "range",
    defaultRangeDate: {
      startDate: new Date("2024-01-01"),
      endDate: new Date("2024-01-01"),
      key: "selection",
    },
  },
  "Sub Station with OA Trend Analysis": {
    type: "trend",
    trendDateOptions: generateDateRangesForYearRange(2022, 2025),
    defaultTrendDates: [{ value: "2024-01-01,2024-01-31", label: "JAN-24" }],
  },
};

export const GridcoOverviewDefaultDates = {
  "By Summary": {
    type: "range",
    defaultRangeDate: {
      startDate: new Date("2024-01-01"),
      endDate: new Date("2024-01-10"),
      key: "selection",
    },
  },

  "By Product": {
    type: "range",
    defaultRangeDate: {
      startDate: new Date("2024-01-01"),
      endDate: new Date("2024-01-05"),
      key: "selection",
    },
  },
};

export const ConsumptionDefaultDates = {
  Demand: {
    type: "range",
    defaultRangeDate: getLast7DaysDateRange(),
  },
  Generation: {
    type: "range",
    defaultRangeDate: getLast7DaysDateRange(),
  },
  Outage: {
    type: "range",
    defaultRangeDate: getLast7DaysDateRange(),
  },
};

export const ExchangeAnalysisDefaultDates = {
  Overview: {
    type: "range",
    defaultRangeDate: getLast7DaysDateRange(),
  },
  "Trend Analysis": {
    type: "trend",
    trendDateOptions: generateMonthsFrom2021ToLatest(),
    defaultTrendDates: [generateMonthsFrom2021ToLatest()[0]],
  },
  Realtime: {
    type: "range",
    defaultRangeDate: [],
    dateRangeDateOptions: [],
    showDateRange: true,
  },
  "Buyers & Sellers": {
    type: "range",
    defaultRangeDate: getLast7DaysDateRange(),
  },
  "Entity Analysis": {
    type: "range",
    defaultRangeDate: getLast7DaysDateRange(),
  },
};
export const HpgcOverviewDefaultDates = {
  Overview: {
    type: "range",
    defaultRangeDate: {
      startDate: new Date("2025-02-09"),
      endDate: new Date("2025-02-10"),
      key: "selection",
    },
  },
};
export const HpgcDemandDefaultDates = {
  "Haryana Load": {
    type: "trend",
    trendDateOptions: (() => {
      const options = [];
      const startYear = 2015;
      const startMonth = 0;
      const currentDate = new Date();
      const endYear = currentDate.getFullYear();
      const endMonth = currentDate.getMonth();

      const monthNames = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ];

      // Loop in reverse order - from current year/month down to start year/month
      for (let year = endYear; year >= startYear; year--) {
        const monthStart = year === endYear ? endMonth : 11;
        const monthEnd = year === startYear ? startMonth : 0;

        for (let month = monthStart; month >= monthEnd; month--) {
          const firstDay = "01";
          const lastDay = String(
            new Date(year, month + 1, 0).getDate(),
          ).padStart(2, "0");
          const monthStr = String(month + 1).padStart(2, "0");

          options.push({
            value: `${year}-${monthStr}-${firstDay},${year}-${monthStr}-${lastDay}`,
            label: `${monthNames[month]}-${String(year).slice(-2)}`,
          });
        }
      }

      return options;
    })(),
    defaultTrendDates: (() => {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);

      const year = yesterday.getFullYear();
      const month = String(yesterday.getMonth() + 1).padStart(2, "0");
      const day = String(yesterday.getDate()).padStart(2, "0");

      const monthNames = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ];
      const monthLabel = monthNames[yesterday.getMonth()];
      const yearShort = String(year).slice(-2);

      return [
        {
          value: `${year}-${month}-${day},${year}-${month}-${day}`,
          label: `${day}-${monthLabel}-${yearShort}`,
        },
      ];
    })(),
  },

  "Peak Analysis": {
    type: "trend",
    trendDateOptions: generatePairedDateRanges(
      { month: 0, year: 2015 },
      { month: new Date().getMonth(), year: new Date().getFullYear() },
      { month: 0, year: 2025 },
      { month: 8, year: 2026 },
      "Model 1",
    ),
    defaultTrendDates: (() => {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);

      const year = yesterday.getFullYear();
      const month = String(yesterday.getMonth() + 1).padStart(2, "0");
      const day = String(yesterday.getDate()).padStart(2, "0");

      const monthNames = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ];
      const monthLabel = monthNames[yesterday.getMonth()];
      const yearShort = String(year).slice(-2);

      return [
        {
          value: `${year}-${month}-${day},${year}-${month}-${day}`,
          label: `${day}-${monthLabel}-${yearShort}`,
        },
      ];
    })(),
  },

  "Trend Analysis": {
    type: "trend",
    trendDateOptions: generatePairedDateRanges(
      { month: 0, year: 2015 }, // Actual start: Jan 2021
      { month: new Date().getMonth(), year: new Date().getFullYear() }, // Actual end: current month/year
      { month: 0, year: 2025 }, // Forecast start: Jan 2025
      { month: 8, year: 2026 }, // Forecast end: Apr 2026
      "Model 1",
    ),
    defaultTrendDates: (() => {
      const today = new Date();
      const previousMonth = new Date(
        today.getFullYear(),
        today.getMonth() - 1,
        1,
      );
      const lastDayOfPreviousMonth = new Date(
        today.getFullYear(),
        today.getMonth(),
        0,
      );

      const year = previousMonth.getFullYear();
      const month = String(previousMonth.getMonth() + 1).padStart(2, "0");
      const lastDay = String(lastDayOfPreviousMonth.getDate()).padStart(2, "0");

      const monthNames = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ];
      const monthLabel = monthNames[previousMonth.getMonth()];
      const yearShort = String(year).slice(-2);

      return [
        {
          value: `${year}-${month}-01,${year}-${month}-${lastDay}`,
          label: `${monthLabel}-${yearShort}`,
        },
        {
          value: `${year}-${month}-01,${year}-${month}-${lastDay}, Model 1`,
          label: `${monthLabel}-${yearShort} (Forecast)`,
          forecast: true,
          model: "Model 1",
        },
      ];
    })(),
  },

  "Forecast Haryana Load": {
    type: "trend",
    trendDateOptions: (() => {
      const options = [];
      const startYear = 2025;
      const startMonth = 10;
      const endYear = 2026;
      const endMonth = 11;

      const monthNames = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ];

      for (let year = startYear; year <= endYear; year++) {
        const monthStart = year === startYear ? startMonth : 0;
        const monthEnd = year === endYear ? endMonth : 11;

        for (let month = monthStart; month <= monthEnd; month++) {
          const firstDay = "01";
          const lastDay = String(
            new Date(year, month + 1, 0).getDate(),
          ).padStart(2, "0");
          const monthStr = String(month + 1).padStart(2, "0");

          options.push({
            value: `${year}-${monthStr}-${firstDay},${year}-${monthStr}-${lastDay}`,
            label: `${monthNames[month]}-${String(year).slice(-2)}`,
          });
        }
      }

      return options;
    })(),
    defaultTrendDates: (() => {
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);

      const monthNames = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ];

      // Today's date
      const todayYear = today.getFullYear();
      const todayMonth = String(today.getMonth() + 1).padStart(2, "0");
      const todayDay = String(today.getDate()).padStart(2, "0");
      const todayMonthLabel = monthNames[today.getMonth()];
      const todayYearShort = String(todayYear).slice(-2);

      // Tomorrow's date
      const tomorrowYear = tomorrow.getFullYear();
      const tomorrowMonth = String(tomorrow.getMonth() + 1).padStart(2, "0");
      const tomorrowDay = String(tomorrow.getDate()).padStart(2, "0");
      const tomorrowMonthLabel = monthNames[tomorrow.getMonth()];
      const tomorrowYearShort = String(tomorrowYear).slice(-2);

      return [
        {
          value: `${todayYear}-${todayMonth}-${todayDay},${todayYear}-${todayMonth}-${todayDay}`,
          label: `${todayDay}-${todayMonthLabel}-${todayYearShort}`,
        },
        {
          value: `${tomorrowYear}-${tomorrowMonth}-${tomorrowDay},${tomorrowYear}-${tomorrowMonth}-${tomorrowDay}`,
          label: `${tomorrowDay}-${tomorrowMonthLabel}-${tomorrowYearShort}`,
        },
      ];
    })(),
  },
};

export const HaryanaPowerProcurement = {
  "GNA/TGNA": {
    type: "range",
    defaultRangeDate: {
      startDate: (() => {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        return yesterday;
      })(),
      endDate: (() => {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        return yesterday;
      })(),
      key: "selection",
    },
  },
};

export const ExchangeAnalysisHPPCDefaultDates = {
  Collective: {
    type: "range",
    defaultRangeDate: getLast7DaysDateRange(),
  },
  "Trend Analysis": {
    type: "trend",
    trendDateOptions: generateMonthsFrom2021ToLatest(),
    defaultTrendDates: [generateMonthsFrom2021ToLatest()[0]],
  },
  Realtime: {
    type: "range",
    defaultRangeDate: [],
    dateRangeDateOptions: [],
    showDateRange: true,
  },
  "Buyers & Sellers": {
    type: "range",
    defaultRangeDate: getLast7DaysDateRange(),
  },
  "Entity Analysis": {
    type: "range",
    defaultRangeDate: getLast7DaysDateRange(),
  },
};

export const PowerAnalyticsDefaultDates = {
  "Power Market": {
    type: "range",
    defaultRangeDate: {
      startDate: (() => {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        return yesterday;
      })(),
      endDate: new Date(), // Today
    },
    trendDateOptions: (() => {
      const options = [];
      const startYear = 2024;
      const startMonth = 0;
      const currentDate = new Date();
      const endYear = currentDate.getFullYear();
      const endMonth = currentDate.getMonth();

      const monthNames = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ];

      // Loop in reverse order - from current year/month down to start year/month
      for (let year = endYear; year >= startYear; year--) {
        const monthStart = year === endYear ? endMonth : 11;
        const monthEnd = year === startYear ? startMonth : 0;

        for (let month = monthStart; month >= monthEnd; month--) {
          const firstDay = "01";
          const lastDay = String(
            new Date(year, month + 1, 0).getDate(),
          ).padStart(2, "0");
          const monthStr = String(month + 1).padStart(2, "0");

          options.push({
            value: `${year}-${monthStr}-${firstDay},${year}-${monthStr}-${lastDay}`,
            label: `${monthNames[month]}-${String(year).slice(-2)}`,
          });
        }
      }

      return options;
    })(),
    defaultTrendDates: (() => {
      const today = new Date();
      const date_4_days_back = new Date(today);
      date_4_days_back.setDate(today.getDate() - 4);

      const date_3_days_back = new Date(today);
      date_3_days_back.setDate(today.getDate() - 3);

      const monthNames = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ];

      // 4 Days Back
      const year4 = date_4_days_back.getFullYear();
      const month4 = String(date_4_days_back.getMonth() + 1).padStart(2, "0");
      const day4 = String(date_4_days_back.getDate()).padStart(2, "0");
      const monthLabel4 = monthNames[date_4_days_back.getMonth()];
      const yearShort4 = String(year4).slice(-2);

      // 3 Days Back
      const year3 = date_3_days_back.getFullYear();
      const month3 = String(date_3_days_back.getMonth() + 1).padStart(2, "0");
      const day3 = String(date_3_days_back.getDate()).padStart(2, "0");
      const monthLabel3 = monthNames[date_3_days_back.getMonth()];
      const yearShort3 = String(year3).slice(-2);

      return [
        {
          value: `${year4}-${month4}-${day4},${year4}-${month4}-${day4}`,
          label: `${day4}-${monthLabel4}-${yearShort4}`,
        },
        {
          value: `${year3}-${month3}-${day3},${year3}-${month3}-${day3}`,
          label: `${day3}-${monthLabel3}-${yearShort3}`,
        },
      ];
    })(),
  },
};

export const PriceForecastDefaultDates = {
  DAM: {
    type: "range",
    defaultRangeDate: (() => {
      const today = new Date();
      const tommorrow = new Date(today);
      tommorrow.setDate(tommorrow.getDate() + 1);
      const startDate = new Date(today);
      startDate.setDate(today.getDate() - 14);
      return {
        startDate: startDate,
        endDate: tommorrow,
        key: "selection",
      };
    })(),
  },
  RTM: {
    type: "range",
    defaultRangeDate: getLast7DaysDateRange(),
  },
};
